import React from 'react';
import styled from 'styled-components';
import LabelValue from '../../../atoms/LabelValue';

const MenuAppInfoWrapper = styled.div`
  text-align: center;
  margin-top: auto;
  padding-bottom: 20px;
`;

function MenuAppInfo() {
  let label = 'Backend';
  let value = process.env.REACT_APP_BACKEND_BASE_URL;
  if (process.env.NODE_ENV === 'production') {
    label = 'Versão';
    value = `v${process.env.REACT_APP_VERSION}`;
  }

  return (
    <MenuAppInfoWrapper>
      <LabelValue
        label={label}
        value={value}
        align="center"
        size="small"
      />
    </MenuAppInfoWrapper>
  );
}

export default MenuAppInfo;
